import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/Clube";
import { pageHead, faqJsonLd, breadcrumbJsonLd, SITE_URL } from "@/lib/seo";
import { PLANOS, VENDAS_ABERTAS } from "@/data/clube";
import { exigirClubeNoAr } from "@/lib/clube";

const produtoJsonLd = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Clube Braussie",
  description:
    "Assinatura com cardápio semanal montado nas ofertas do Coles, Woolworths e Aldi, porções ajustadas por pessoa, lista de compras com preço, guias, comunidade e desafios. Para brasileiros na Austrália.",
  brand: { "@type": "Brand", name: "Clara Camille" },
  url: `${SITE_URL}/clube`,
  offers: [
    { "@type": "Offer", name: "Fundadora (50 vagas)", price: PLANOS.fundadora.preco, priceCurrency: "AUD", url: `${SITE_URL}/clube#vaga`, availability: VENDAS_ABERTAS ? "https://schema.org/InStock" : "https://schema.org/PreOrder" },
    { "@type": "Offer", name: "Mensal", price: PLANOS.mensal.preco, priceCurrency: "AUD", url: `${SITE_URL}/clube#planos`, availability: VENDAS_ABERTAS ? "https://schema.org/InStock" : "https://schema.org/PreOrder" },
    { "@type": "Offer", name: "Família", price: PLANOS.familia.preco, priceCurrency: "AUD", url: `${SITE_URL}/clube#planos`, availability: VENDAS_ABERTAS ? "https://schema.org/InStock" : "https://schema.org/PreOrder" },
    { "@type": "Offer", name: "Anual", price: PLANOS.anual.preco, priceCurrency: "AUD", url: `${SITE_URL}/clube#planos`, availability: VENDAS_ABERTAS ? "https://schema.org/InStock" : "https://schema.org/PreOrder" },
  ],
};

export const Route = createFileRoute("/clube/")({
  beforeLoad: exigirClubeNoAr,
  head: () =>
    pageHead({
      title: "Clube Braussie: cardápio semanal com as ofertas do seu mercado | Clara Camille",
      description:
        "Cardápio da semana montado nas ofertas do Coles, Woolworths ou Aldi, nas suas medidas, com a lista de compras com preço. Comida brasileira, por uma nutricionista brasileira. 50 vagas da Turma Fundadora a A$ 19 por mês.",
      path: "/clube",
      ogTitle: "Clube Braussie: comer bem gastando menos, no mercado onde você compra",
      ogDescription: "Cardápio toda quarta com as ofertas do seu mercado, nas suas medidas. 50 vagas da Turma Fundadora a A$ 19 por mês.",
      ogImage: `${SITE_URL}/og-clube.jpg`,
      jsonLd: [breadcrumbJsonLd([{ name: "Clube Braussie", path: "/clube" }]), produtoJsonLd, faqJsonLd(faqItems)],
    }),
  component: Page,
});
